import React from 'react';
import { useParams } from 'react-router';
import { FiltersList } from '../FiltersList/FiltersList';
import ErrorMessagesList from '../ErrorMessagesList/ErrorMessagesList';
import ResultsView from 'src/components/Results/ResultsView';
import styles from './ScriptErrorDetails.module.less';

type RouteParams = {
  appId: string;
  siteCode: string;
  scriptName: string;
};

export const ScriptErrorDetails: React.FC = () => {
  const { appId, siteCode, scriptName } = useParams<RouteParams>();

  // TODO: this is hardcoded just for demostration purposes and going to be removed
  // once it's clear which data should be shown
  const tempDummyData = {
    runId: '22102233',
    jobId: '',
    jobName: '',
  };

  return (
    <div>
      <FiltersList appId={appId} siteCode={siteCode} scriptName={scriptName} />
      <div className={styles.qualityIndexing}>
        <ResultsView
          selectedRowKeyVal={[]}
          jobid={tempDummyData.jobId}
          runId={tempDummyData.runId}
          jobName={tempDummyData.jobName}
          resultid="-1"
        />
      </div>
      <ErrorMessagesList />
    </div>
  );
};
